import { Box, Breakpoint, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import { ReactNode } from 'react';

const LEGEND_ITEMS: { title: string; icon: ReactNode }[] = [
  {
    title: 'No Issues',
    icon: <CheckCircleIcon color="success" />,
  },
  { title: 'Incident', icon: <WarningIcon color="warning" /> },
  { title: 'Outage', icon: <DoNotDisturbOnIcon color="error" /> },
];

// the breakpoint at which the Legend layout changes
const BREAKPOINT_TRIGGER: Breakpoint | number = 'md';

const renderLegendItems = () => {
  return LEGEND_ITEMS.map(({ title, icon }) => {
    return (
      <Box
        sx={theme => ({
          display: 'flex',
          alignItems: 'center',
          // setting top and bottom margins helps with vertical spacing when wrapping
          // but does not significantly affect spacing when not wrapping
          mb: 0.5,
          mt: 0.5,
          [theme.breakpoints.down(BREAKPOINT_TRIGGER)]: {
            mr: 2,
          },
          [theme.breakpoints.up(BREAKPOINT_TRIGGER)]: {
            mr: 4,
          },
        })}
        key={title}
      >
        {icon}
        <Typography variant="body1" ml={1}>
          {title}
        </Typography>
      </Box>
    );
  });
};

const Legend = () => {
  return (
    <Box
      sx={theme => ({
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        marginTop: 3,
        marginBottom: 3,
        flexWrap: 'wrap',
        [theme.breakpoints.down(BREAKPOINT_TRIGGER)]: {
          justifyContent: 'center',
        },
        [theme.breakpoints.up(BREAKPOINT_TRIGGER)]: {
          justifyContent: 'space-between',
        },
      })}
    >
      <Typography
        variant="h6"
        sx={theme => ({
          [theme.breakpoints.down(BREAKPOINT_TRIGGER)]: {
            width: '100%',
          },
        })}
      >
        Current Status
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}
      >
        {renderLegendItems()}
      </Box>
    </Box>
  );
};

export default Legend;
